import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=3c652cd0&scoped=true"
import script from "./order-card.vue?vue&type=script&lang=js"
export * from "./order-card.vue?vue&type=script&lang=js"
import style0 from "./order-card.vue?vue&type=style&index=0&id=3c652cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c652cd0",
  null
  
)

export default component.exports